import { connect } from "react-redux";
import ReactDatePicker from "../../../../../components/reactDatePicker/reactDatePicker";
import { actionCreators } from "../redux/sagas/membershipBreakdown/membershipBreakdown";

export default connect(
  state => ({
    calendarEndDate: state.membershipBreakdown.currentUser.params.calendarEndDate,
    minDate: state.membershipBreakdown.currentUser.params.calendarStartDate,
    startDate: state.membershipBreakdown.date
  }),
  {
    updateDates: newSelectedDate => actionCreators.updateDate(newSelectedDate)
  }
)(ReactDatePicker);
